/**
 * CTA de evolução — evidência visual distinta do "Iniciar atendimento".
 */
import { Button } from "@mui/material";
import { PlayArrow, Timeline } from "@mui/icons-material";

interface EvolutionButtonProps {
  hasOpenEvolution?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  onClick: () => void;
}

export function EvolutionButton({
  hasOpenEvolution = false,
  loading = false,
  fullWidth = false,
  onClick,
}: EvolutionButtonProps) {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={onClick}
      disabled={loading}
      startIcon={hasOpenEvolution ? <PlayArrow /> : <Timeline />}
      fullWidth={fullWidth}
      sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2.5 }}
    >
      {hasOpenEvolution ? "Continuar evolução" : "Evoluir paciente"}
    </Button>
  );
}
